"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAppConfigArgsValidator = exports.updateAppConfigArgsSchema = exports.deleteAppArgsValidator = exports.deleteAppArgsSchema = exports.createCustomAppArgsValidator = exports.createCustomAppArgsSchema = exports.createCustomAppFromAppConfig = exports.appConfigValidator = exports.appConfigSchema = void 0;
var suretype_1 = require("suretype");
var common_1 = require("../common");
var urlSchema = suretype_1.v.anyOf([
    suretype_1.v.string(),
    suretype_1.v.object({
        community: suretype_1.v.string().required(),
        personal: suretype_1.v.string().required()
    })
]);
var stringArraySchema = suretype_1.v.array(suretype_1.v.string());
var permissionsSchema = stringArraySchema.unique(true);
exports.appConfigSchema = suretype_1.v.object({
    name: suretype_1.v.string().required(),
    description: suretype_1.v.string().required(),
    icons: suretype_1.v.object({
        app: suretype_1.v.string().format("uri").required(),
        channel: suretype_1.v.string().required() // can contain channel type as wildcard
    }).required(),
    version: suretype_1.v.string().required(),
    // TODO what is permissions used for?
    permissions: suretype_1.v.anyOf([
        permissionsSchema,
        suretype_1.v.object({
            community: permissionsSchema.required(),
            personal: permissionsSchema.required()
        })
    ]).required(),
    scopes: suretype_1.v.array([
        suretype_1.v.string().const("community"),
        suretype_1.v.string().const("personal")
    ]).unique(true).required(),
    pages: suretype_1.v.object({
        origin: suretype_1.v.string().required(),
        // channel: urlSchema.required(),
        // notificationContext: urlSchema,
        // create: urlSchema,
        // update: urlSchema,
        // delete: urlSchema
    }).required(),
    api: suretype_1.v.object({
        // NOTE api client secrets configured separately
        endpoint: urlSchema.required(),
        // create: v.string(),
        // update: v.string(),
        // delete: v.string()
    }),
    forms: suretype_1.v.object({
        create: urlSchema,
        update: urlSchema,
    })
});
exports.appConfigValidator = (0, suretype_1.compile)(exports.appConfigSchema);
// ==========================
// actions
// ==========================
function createCustomAppFromAppConfig(_a) {
    var publisherId = _a.publisherId, appConfig = _a.appConfig, appApiClientId = _a.appApiClientId, openIdClientId = _a.openIdClientId;
    return {
        details: {
            openIdClientId: openIdClientId,
            appApiClientId: appApiClientId,
            config: appConfig
        },
        // filter
        publisherId: publisherId,
        published: false,
        publishedAt: 0,
    };
}
exports.createCustomAppFromAppConfig = createCustomAppFromAppConfig;
exports.createCustomAppArgsSchema = suretype_1.v.object({
    // appId: idSchema.required(),
    // app is directly added to community (no app store entry)
    // communityId: idSchema.required(),
    appConfig: exports.appConfigSchema.required(),
});
exports.createCustomAppArgsValidator = (0, suretype_1.compile)(exports.createCustomAppArgsSchema);
// TODO
exports.deleteAppArgsSchema = suretype_1.v.object({
    appId: common_1.idSchema.required(),
});
exports.deleteAppArgsValidator = (0, suretype_1.compile)(exports.deleteAppArgsSchema);
exports.updateAppConfigArgsSchema = suretype_1.v.object({
    appId: common_1.idSchema.required(),
    appConfig: exports.appConfigSchema.required(),
});
exports.updateAppConfigArgsValidator = (0, suretype_1.compile)(exports.updateAppConfigArgsSchema);
